module.exports = __webpack_public_path__ + "img/manager2_blue.34cd14ff.jpg";